import { useState } from 'react';
import { IRadioConfig, defaultState } from './RadioConfigContext';


export default function useRadioConfig() {
  const [radioConfig, setRadioConfig] = useState<IRadioConfig>(defaultState);

  // const setRadioConfig = useCallback((newRadioConfig) => {
  //   setRadioConfigState(newRadioConfig);
  // }, [radioConfig]);

  return {
    radioConfig,
    setRadioConfig,
  }
}